import { IDropdownOption } from '@fluentui/react';
import {
  Chart,
  ChartType,
  Dropdown,
  IChartProps,
  IEmptyMessageProps,
  WidgetPanel,
  widgetPanelStylesInfo,
} from '@h2oai/ui-kit';
import { useCallback, useState } from 'react';

const getChartTypeOptions = () => Object.keys(ChartType).map((key) => ({ key, text: key }));

interface IChartWidgetProps {
  title: string;
  chartProps: IChartProps;
  emptyMessageProps?: IEmptyMessageProps;
  onChangeChartType?: (type: ChartType) => void;
}

export const ChartWidget = ({ title, chartProps, emptyMessageProps, onChangeChartType }: IChartWidgetProps) => {
  const [chartType, setChartType] = useState<ChartType>(chartProps.chartType || ChartType.Bar);
  const onChange = useCallback((_e: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    if (option) {
      const chartType = option.key as ChartType;
      setChartType(chartType);
      onChangeChartType && onChangeChartType(chartType);
    }
  }, []);
  return (
    <WidgetPanel
      styles={widgetPanelStylesInfo}
      style={{ width: '100%' }}
      title={title}
      emptyMessageProps={emptyMessageProps}
    >
      <div
        style={{ display: 'flex', gap: '8px', lineHeight: '32px', position: 'absolute', right: '8px', top: '-40px' }}
      >
        <div>Chart Type</div>
        <Dropdown
          styles={{ root: { width: '200px' } }}
          placeholder="Chart Type"
          options={getChartTypeOptions()}
          selectedKey={chartType}
          onChange={onChange}
        />
      </div>
      <Chart {...chartProps} chartType={chartType} />
    </WidgetPanel>
  );
};
